import { useEffect, useState } from "react";
import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useDisclosure,
    Text,
    Switch,
    Flex
} from "@chakra-ui/react";
import { InfoIconOutlineYellow } from "../../../styles/icons/InfoIconOutlineYellow";
import { getTwoFactorStatus, resetTwoFA } from "../../../hooks/use2Fa";
import { useParams } from "react-router-dom";

export function Modal2FA() {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [defaultStatus, setDefaultStatus] = useState<boolean>(false);
    const [modalType, setModalType] = useState<"activate" | "deactivate" | null>(null);
    const Token = localStorage.getItem("barte-auth-token");
    const { id } = useParams();

    async function getStatusTwoFA() {
        try {
            const response = await getTwoFactorStatus(Number(id), Token);
            setDefaultStatus(Boolean(response));
        } catch (error) {
            console.error("Erro ao obter status 2FA:", error);
        }
    }

    async function getResetSatus() {
        try {
            const response = await resetTwoFA(id, Token)
            if (response.status === 200  || response.status === 204  ) {
                getStatusTwoFA()
                onClose()

            }
        } catch (error) {
            return error
        }
    }

    useEffect(() => {
        getStatusTwoFA();
        //eslint-disable-next-line
    }, []);

    function desativate2FA() {
        getResetSatus()
    }


    const handleToggle = (e) => {
        const isChecked = e.target.checked;
        if (isChecked && !defaultStatus) {
            setModalType("activate");
        } else if (!isChecked && defaultStatus) {
            setModalType("deactivate");
        } else {
            setModalType(null);
        }

        onOpen();
    };

    const handleCloseModal = () => {
        setModalType(null);
        onClose();
    };

    return (
        <>
            <Switch
                id="TwoFa"
                isChecked={defaultStatus}
                size="sm"
                sx={{
                    "& .chakra-switch__track": { backgroundColor: "gray.300" },
                    "& .chakra-switch__track[data-checked]": { backgroundColor: "red.500" },
                    "& .chakra-switch__thumb": { backgroundColor: "white" }
                }}
                onChange={handleToggle}
            />

            <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={handleCloseModal}>
                <ModalOverlay />
                {modalType === "deactivate" && (
                    <ModalContent p="0" gap="8px" borderRadius="2px" alignSelf="center">
                        <Flex p="32px 32px 24px 32px" gap="16px">
                            <Flex>

                                <InfoIconOutlineYellow size={24} />
                            </Flex>
                            <Flex flexDirection="column" gap="8px">
                                <ModalHeader
                                    p="0"
                                    fontSize="16px"
                                    color="rgba(0, 0, 0, 0.85)"

                                >
                                    Desativar Autenticação de dois fatores?
                                </ModalHeader>
                                <ModalBody
                                    p="5px 0"
                                    fontSize="14px"
                                    fontWeight="400"
                                    color="rgba(0, 0, 0, 0.85)">
                                    <Text>Para ativar novamente, o seller deverá utilizar o menu Configurações/Segurança no painel do seller e concluir as configurações do 2FA conforme instruções.
                                    </Text>
                                    <Text>Você não poderá ativar a autenticação novamente.</Text>
                                </ModalBody>
                                <ModalFooter p="0">
                                    <Flex gap="8px">
                                        <Button
                                            fontSize="14px"
                                            fontWeight="400"
                                            h="32px"
                                            onClick={handleCloseModal}
                                            variant="outline"
                                            w="89px"
                                            borderRadius="2px"
                                            color="black"
                                        >
                                            Cancelar
                                        </Button>
                                        <Button
                                            fontSize="14px"
                                            fontWeight="400"
                                            backgroundColor="var(--Yellow-400, rgba(198, 138, 49, 1))"
                                            color="white"
                                            w="93px"
                                            h="32px"
                                            onClick={desativate2FA}
                                            borderRadius="2px"

                                        >
                                            Desativar
                                        </Button>
                                    </Flex>
                                </ModalFooter>
                            </Flex>
                        </Flex>
                    </ModalContent>
                )}

                {modalType === "activate" && (
                    <ModalContent p="0" gap="8px" borderRadius="2px" alignSelf="center">
                        <Flex p="32px 32px 24px 32px" w="400" gap="16px" lineHeight="22px">
                            <Flex>
                                <InfoIconOutlineYellow size={24} />

                            </Flex>
                            <Flex flexDirection="column" gap="8px">
                                <ModalHeader p="0" fontSize="16px" fontWeight="600" color="rgba(0, 0, 0, 0.85)">
                                    Você não tem permissão para ativar a autenticação 2FA
                                </ModalHeader>
                                <ModalBody p="5px 0 " fontSize="14px" fontWeight="400" color="rgba(0, 0, 0, 0.85)">
                                    <Text>
                                        Apenas o seller pode ativar a autenticação através do menu Configurações/Segurança
                                        no painel do seller para concluir as configurações do 2FA.
                                    </Text>
                                </ModalBody>
                                <ModalFooter p="0">
                                    <Flex gap="8px">
                                        <Button variant="outline"
                                            fontSize="14px"
                                            fontWeight="400"
                                            borderRadius="2px"
                                            h="32px"
                                            w="49px"
                                            color="black"
                                            onClick={handleCloseModal}>
                                            Ok
                                        </Button>
                                    </Flex>
                                </ModalFooter>
                            </Flex>
                        </Flex>
                    </ModalContent>
                )}
            </Modal>
        </>
    );
}
